require('./helpers/bundle-manifest').register(JSON.parse("{\"GfUJO\":\"index.js\",\"2WQV8\":\"chosen.jquery.324dccf6.js\"}"));